import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import {
  cookingStorySearchItem,
  createKitchenItem,
  createshoppingListItem,
  groceryCategoryList,
  kitchenSearchItem,
  shoppingListItem,
  shoppingListItemInCategory,
} from 'src/app/core/model/api-response/cooking-story-model';
import { DietApiService } from '../plan-repository/diet-api.service';
import { FoodDataService } from '../plan-repository/food-data.service';
import { PersoanlService } from '../plan-repository/persoanl.service';
import { CookingStoryGroceryApiService } from './cooking-story-kitchen-api.service';
import { CookingStoryKitchenDataService } from './cooking-story-kitchen-data.service';

@Injectable({
  providedIn: 'root',
})
export class CookingStoryShoppinglistDateService {
  private shoppinglistItem: Map<string, kitchenSearchItem> = new Map();
  private unsavedUnit: Map<string, string> = new Map();
  private unsavedAmount: Map<string, number> = new Map();
  private unsavedDescription: Map<string, string> = new Map();

  private currentEditItem: string;
  update: Subject<boolean> = new Subject();
  refetch: Subject<boolean> = new Subject();
  getNewQuickAdd: Subject<boolean> = new Subject();

  unitlist;
  type: 'edit' | 'search';
  // Home
  private shoppingListHomeItems: Map<string, shoppingListItem> = new Map();
  foodIds: string[] = [];
  GroceryCategory: groceryCategoryList[];

  constructor(
    private PersoanlService: PersoanlService,
    private foodDataService: FoodDataService,
    private dietApiService: DietApiService,
    private cookingStoryKitchenApiService: CookingStoryGroceryApiService,
    private cookingStoryKitchenDataService: CookingStoryKitchenDataService
  ) {}
  async prepearSearchFood(food: cookingStorySearchItem[]) {
    let foodIds = food
      .map((e) => {
        const ids = e.foods
          .map((b) => {
            return b?._id;
          })
          .flat();
        return ids;
      })
      .flat();

    let f = await this.foodDataService.getFoods(foodIds);
    let missingFood = [];

    f = f.map((e, i) => {
      if (!e) {
        missingFood.push(foodIds[i]);

        return foodIds[i];
      } else {
        return e;
      }
    });

    if (missingFood.length > 0) {
      await this.dietApiService.getFoods(missingFood, true);
      missingFood = await this.foodDataService.getFoods(missingFood);

      f = await f.map((v, i) => {
        if (typeof v === 'string') {
          let data = missingFood.find((d) => {
            return d._id == f[i];
          });

          return data;
        } else {
          return f[i];
        }
      });
    }

    await food.map((e) => {
      e.foods.map((b) => {
        let data = f.find((d, i) => {
          if (!d) {
            return b.food == (foodIds[i] as any);
          }
          return b.food == d?._id;
        });
        b.food = data;
      });
    });

    return Promise.resolve(food);
  }

  async prepearMostUseFood(food: shoppingListItem[]) {
    for (let item of food) {
      let data = await this.foodDataService.getFood(item.food as string);
      if (data) {
        item.food = data;
      } else {
        await this.dietApiService.getFoods([item._id as string], true);
        data = await this.foodDataService.getFood(item._id as string);
        item.food = data;
      }
      item.amount = null;
      item.unitDescription = null;
      item.description = null;
      item.unit = null;
    }
    return food;
  }

  async getUnitList() {
    if (!this.unitlist) {
      await this.PersoanlService.getFoodUnitId().then((res) => {
        this.unitlist = (res.getData().getFoodUnitId() as any).result;
      });
    }
    return await this.unitlist;
  }
  changeActiveItem(id: string): void {
    this.currentEditItem = id;
  }
  changeType(data: 'edit' | 'search') {
    this.type = data;
  }
  getActiveItem(): string {
    return this.currentEditItem;
  }
  getItems(): kitchenSearchItem[] {
    const data = Array.from(this.shoppinglistItem, ([key, value]) => {
      return value;
    });
    return data;
  }
  addItem(edittedItem: kitchenSearchItem) {
    const item = this.getItem(edittedItem.id);

    if (!item) {
      this.shoppinglistItem.set(edittedItem.id, edittedItem);
    } else {
      this.shoppinglistItem.delete(edittedItem.id);
    }
  }
  JustaddItem(edittedItem: kitchenSearchItem) {
    const item = this.getItem(edittedItem.id);
    if (!item) {
      this.shoppinglistItem.set(edittedItem.id, edittedItem);
    }
  }
  clearshoppingListItems() {
    this.shoppinglistItem.clear();
    this.shoppingListHomeItems.clear();
    this.unsavedUnit.clear();
    this.unsavedAmount.clear();
    this.unsavedDescription.clear();
    this.changeActiveItem(null);
  }
  getUnsavedItem(id: string) {
    return this.unsavedUnit.get(id);
  }
  addUnsaved(id: string, unit: string) {
    this.unsavedUnit.set(id, unit);
  }
  removeUnsavedUnit(id: string) {
    this.unsavedUnit.delete(id);
  }
  getUnsaveDescription(id: string) {
    return this.unsavedDescription.get(id);
  }
  addUnsavedDescription(id: string, description: string) {
    this.unsavedDescription.set(id, description);
  }
  removeUnsavedDescription(id: string) {
    this.unsavedDescription.delete(id);
  }
  updateSave(id: string, item: kitchenSearchItem) {
    this.shoppinglistItem.set(id, item);
  }
  SaveAndUpdate(id: string, item: kitchenSearchItem) {
    const data = this.shoppingListFilter(item);

    this.cookingStoryKitchenApiService
      .updateShoppingListItem(id, data)
      .then((res) => {
        if (res.isSuccess()) {
          this.shoppinglistItem.set(id, item);
          console.log(this.shoppinglistItem.get(id));

          this.update.next(true);
        }
      });
  }

  getUnsavedAmount(id: string) {
    return this.unsavedAmount.get(id);
  }
  addUnsavedAmount(id: string, amount: number) {
    this.unsavedAmount.set(id, amount);
  }
  removeUnsavedAmount(id: string) {
    this.unsavedAmount.delete(id);
  }

  updateItem(id: string, edittedItem: kitchenSearchItem) {
    this.shoppinglistItem.set(id, edittedItem);
    this.update.next(true);
  }
  updateAmount(amount: number) {
    const active = this.getItem(this.currentEditItem);

    const data = new kitchenSearchItem(
      active.food,
      active.quickAdd,
      amount,
      active.unit,
      active.unitDescription,
      active.description,
      active.expireDate,
      active.name,
      active.foodUnitRatioArray,
      active.save,
      active.id
    );

    this.updateItem(this.currentEditItem, data);
  }

  getItem(id: string) {
    return this.shoppinglistItem.get(id);
  }

  updateUnit(id: string) {
    const active = this.getItem(this.currentEditItem);
    active.unit = id;
    this.updateItem(this.currentEditItem, active);
  }
  // Home

  async addshoppingListItems(items: shoppingListItem[]) {
    items.map((item) => {
      this.shoppingListHomeItems.set(item._id, item);
    });
    return await this.getAllshoppingListItemInCategory();
  }
  async getupdateListItem(items: shoppingListItemInCategory[]) {
    for (let item of items) {
      for (const [i, food] of item.foods.entries()) {
        const data = await this.getItem(food._id);
        if (!data) {
          item.foods.splice(i, 1);
        } else {
          if (data.quickAdd) {
            food.quickAdd = data.quickAdd;
          } else {
            food.unit = data.unit;
            food.amount = data.amount;
          }
        }
      }
    }

    return Promise.resolve(items);
  }
  deleteItemList(ids: string[], update: boolean = true) {
    this.cookingStoryKitchenApiService.deleteShoppingList(ids).then((res) => {
      if (res.isSuccess()) {
        ids.map((id) => {
          this.shoppinglistItem.delete(id);
          this.shoppingListHomeItems.delete(id);
        });
        if (update) {
          this.update.next(true);
        }
      }
    });
    return Promise.resolve(true);
  }

  async getAllshoppingListItemInCategory() {
    const shoppingListItems = Array.from(
      this.shoppingListHomeItems,
      ([key, value]) => {
        return value;
      }
    );

    const categories = this.GroceryCategory.map(
      (category: groceryCategoryList) => category
    );
    let foods = categories.map((category) => {
      const categorieFood = shoppingListItems.filter(
        (item) => item.groceryCategory == category._id
      );
      return new shoppingListItemInCategory(
        category._id,
        category.tags,
        category.name,
        categorieFood
      );
    });

    return this.prepearFood(foods);
    // return data;
  }

  saveGroceryCategory(items: groceryCategoryList[]) {
    this.GroceryCategory = items;
  }
  async prepearFood(foods: shoppingListItemInCategory[]) {
    for (let categorie of foods) {
      for (let food of categorie.foods) {
        if (typeof food.food !== 'string' && food.food) {
          food.food = food.food._id ? food.food._id : food.food.id;
        }
        if (food.food && food.food != '' && typeof food.food == 'string') {
          let data = await this.foodDataService.getFood(food.food as string);

          if (data) {
            food.food = data;
          } else {
            await this.dietApiService.getFoods([food.food as string], true);
            data = await this.foodDataService.getFood(food.food as string);
            food.food = data;
          }
        }
      }
    }
    return Promise.resolve(foods);
  }
  saveshoppingListData() {
    const data = this.getItems().map((item) => {
      return this.shoppingListFilter(item);
    });
    return this.cookingStoryKitchenApiService
      .saveShoppingListItems(data)
      .then((res) => {
        if (res.isSuccess()) {
          return Promise.resolve(true);
        }
      });
  }
  saveQuickAdd(data: createshoppingListItem[]) {
    this.cookingStoryKitchenApiService
      .saveShoppingListItems(data)
      .then((res) => {
        if (res.isSuccess()) {
          res
            .getData()
            .getCreateShoppingListRecpoce()
            .shoppingList.map((item) => {
              const quickAdd = new kitchenSearchItem(
                null,
                item.quickAdd,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                true,
                item._id
              );
              this.addshoppingListItems([item]);
              this.addItem(quickAdd);
              this.getNewQuickAdd.next(true);
            });
        }
      });
  }

  shoppingListFilter(item: kitchenSearchItem) {
    const data = new createshoppingListItem(
      item.food,
      parseInt(item.amount as any),
      item.unit,
      item.unitDescription,
      item.description,
      item.quickAdd
    );

    if (item.unit == 'nothing') {
      delete data.unit;
    }
    if (!item.amount) {
      delete data.amount;
    }
    if (!item.description && typeof item.description !== 'string') {
      delete data.description;
    }
    if (!item.unitDescription && typeof item.description !== 'string') {
      delete data.unitDescription;
    }
    if (!item.unit) {
      delete data.unit;
    }
    if (item.quickAdd) {
      delete data.amount;
      delete data.unit;
      delete data.unitDescription;
      delete data.description;
      delete data.food;
    } else {
      delete data.quickAdd;
    }
    return data;
  }
  kitchenFilter(item: kitchenSearchItem) {
    const date = item.expireDate ? item.expireDate.getTime() : null;
    const data = new createKitchenItem(
      item.food,
      parseInt(item.amount as any),
      item.unit,
      date,
      item.unitDescription,
      item.description,
      item.quickAdd
    );
    if (!data.quickAdd) {
      delete data.quickAdd;
    }

    if (item.unit == 'nothing') {
      delete data.unit;
    }
    if (!data.amount) {
      delete data.amount;
    }
    if (!data.expireDate) {
      delete data.expireDate;
    }
    if (!data.description && typeof data.description !== 'string') {
      delete data.description;
    }
    if (!data.unitDescription && typeof data.description !== 'string') {
      delete data.unitDescription;
    }
    if (!data.unit) {
      delete data.unit;
    }
    if (data.quickAdd) {
      delete data.amount;
      delete data.unit;
      delete data.food;
      delete data.expireDate;
      delete data.unitDescription;
      delete data.description;
    }
    return data;
  }
  async moveToKitcchen(ids: string[]) {
    const items = ids.map((id) => this.getItem(id));
    const kitcchenItems = items.map((data) => {
      const item = new kitchenSearchItem(
        data.food,
        data.quickAdd,
        data.amount,
        data.unit,
        data.unitDescription,
        data.description,
        data.expireDate,
        data.name
      );
      return this.kitchenFilter(item);
    });

    this.cookingStoryKitchenApiService
      .saveKitchenItems(kitcchenItems)
      .then((res) => {
        if (res.isSuccess()) {
          this.deleteItemList(ids, false).then((bool) => {
            this.cookingStoryKitchenDataService.refetch.next();
            this.refetch.next();
          });
        }
      });
  }
  deleteSelectedItems(ids: string[]) {
    this.deleteItemList(ids).then((bool) => {
      this.cookingStoryKitchenDataService.refetch.next();
      this.refetch.next();
    });
  }
}
